import { useContext, useEffect, useState } from "react";
import {
  Box, Button, MenuItem, FormControl, Grid, IconButton, InputLabel, Paper, Select,
  Stack, Table, TableBody, TableCell, Container, TableContainer, TableHead, TableRow,
  styled, tableCellClasses, Pagination, InputBase, TextField, InputAdornment, Typography,
  Divider, Backdrop, CircularProgress, Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import { AlertType, SortType } from "../../../types/AlertType";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import FunctionsIcon from "@mui/icons-material/Functions";
import { tableStyle } from "../parametrage/Pays/Pays";
import SaisieAgentRow from "./SaisieAgentRow";
import { DataRef } from "../../../types/DataRef";
import Cookies from "universal-cookie";
import { ConnectedUser } from "../../../utils/utils";
import AddSaisieAgentForm from "../../forms/SaisieManager/AddSaisieAgentForm";
import TabSort from "../../element/sort/TabSort";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import OptionalWidthModal from "../../../commons/optional-width-modal/OptionalWidthModal";
import {
  PROFIL_ADV, PROFIL_SUPER_ADMIN, PROFIL_DIRECTION, PROFIL_GESTIONNER_HEURE_PROD,
  PROFIL_MANAGER
} from "../../../constants/Constants";
import axios, { AxiosInstance } from "axios";
import CheckAttr from "../../../utils/CheckAttr";
import CumulArticle from "../../forms/SaisieManager/CumulArticle";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loggoutUser } from "../../../redux/actions/logginUser";
import { MediaQueryContext } from "../../../utils/contextes/MediaQueryContext";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

const tableColumnTittles = [
  {
    id: 1,
    tittle: "Pays de production",
    property: "pays.libelle",
    toSort: true,
  },
  {
    id: 2,
    tittle: "Bu",
    property: "bus.libelle",
    toSort: true,
  },
  {
    id: 3,
    tittle: "Client",
    property: "clients.libelle",
    toSort: true,
  },
  {
    id: 4,
    tittle: "Operation",
    property: "operations.libelle",
    toSort: true,
  },
  {
    id: 5,
    tittle: " Code article",
    property: "code_articles.libelleCodeArticle",
    toSort: false,
  },
  {
    id: 6,
    tittle: "Désignation article",
    property: "articles.libelle",
    toSort: true,
  },
  {
    id: 7,
    tittle: "Date saisie",
    property: "saisie_managers.date_saisie",
    toSort: true,
  },
  {
    id: 8,
    tittle: "Heures CA",
    property: "saisie_managers.heures_ca",
    toSort: true,
  },
  {
    id: 9,
    tittle: "Actes",

    property: "saisie_managers.actes",
    toSort: true,
  },
  {
    id: 10,
    tittle: "Heures Prod",
    property: "saisie_managers.heuresprod",
    toSort: true,
  },
  {
    id: 12,
    tittle: "Actions",
    toSort: false,
  },
];

export interface DataSaisieManager {
  id: number;
  pays_id: number;
  pays_libelle: string;
  bu_id: number;
  bu_libelle: string;
  client_id: number;
  client_libelle: string;
  article_id: number;
  article_libelle: string;
  article_desactive_date: Date;
  article_semi_automatique: number;
  code_article_id: number;
  code_article_libelle: string;
  operation_id: number;
  operation_libelle: string;
  devises_id: number;
  devises_libelle: string;
  cout_id: number;
  cout: string;
  tarif_id: number;
  tarifheure: string;
  tarifacte: string;
  date_saisie: Date;
  heuresprod: string;
  heures_ca: string;
  actes: number;
  dmt: string;
  manual: number;
  status: 'validée' | 'envoyée' | null;
}

export interface SortParams {
  column?: string;
  orderBy?: SortType;
}

export interface PeriodSaisi {
  date_debut: string;
  date_fin: string;
  date_verrouillage: string;
}

export interface IPeriodeCloture {
  id: number;
  annee: number;
  date_cloture: string;
  date_debut: string;
  date_fin: string;
}

interface FilterParams {
  pays: string;
  bu: string;
  client: string;
  operation: string;
  article: string;
  date_debut: string;
  date_fin: string;
}

const initialFilter: FilterParams = {
  pays: "",
  bu: "",
  client: "",
  operation: "",
  article: "",
  date_debut: "",
  date_fin: "",
};

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

const SaisieAgent = () => {
  const { isDesktopOrLaptop } = useContext(MediaQueryContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [reloadList, setReloadList] = useState<boolean>(false);
  const [openCumulModal, setOpenCumulModal] = useState<boolean>(false);
  const [dateNotValidate, setDateNotValidate] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<number | false>(false);

  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [totalData, setTotalData] = useState<number>(0);
  const [sortedColumn, setSortedColumn] = useState<number>(0);
  const [filter, setFilter] = useState<FilterParams>(initialFilter);
  const [periodSaisi, setPeriodSaisi] = useState<PeriodSaisi>({
    date_debut: "",
    date_fin: "",
    date_verrouillage: "",
  });

  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [articleSearch, setArticleSearch] = useState<string>("");
  const [alertType, setAlertType] = useState<AlertType>("success");

  const [dataPays, setDataPays] = useState<DataRef[]>([]);
  const [dataPaysInAssociations, setDataPaysInAssociations] = useState<
    DataRef[]
  >([]);
  const [dataFilteredPays, setDataFilteredPays] = useState<DataRef[]>([]);
  const [dataBusinessUnits, setDataBusinessUnits] = useState<DataRef[]>([]);
  const [dataClients, setDataClients] = useState<DataRef[]>([]);
  const [dataOperations, setDataOperations] = useState<DataRef[]>([]);
  const [dataArticles, setDataArticles] = useState<DataRef[]>([]);
  const [saisieAgents, setSaisieAgents] = useState<DataSaisieManager[]>([]);
  const [allPeriodeClotured, setAllPeriodeClotured] = useState<
    IPeriodeCloture[]
  >([]);

  const [columnToSort, setColumnToSort] = useState<SortParams | undefined>(
    undefined
  );

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove("jwt", { path: "/" });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  const user = ConnectedUser();

  const retrieveData = () => {
    // Récupère les saisies managers
    setIsLoading(true);
    const data = {
      filter,
      sortby: columnToSort,
      articleSearch,
      rowsPerPage,
      page,
    };

    http
      .post("saisie/manager/list", data)
      .then((res) => {
        const { total, data } = res.data;

        setTotalData(total);
        Array.isArray(data) && setSaisieAgents(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    // Récupère les saisies managers
    if (!dateNotValidate) {
      retrieveData();
    }
  }, [filter, rowsPerPage, columnToSort, page, reloadList]);

  useEffect(() => {
    // Récupère tous les pays
    http
      .get("getallpays")
      .then((res) => {
        Array.isArray(res.data) && setDataPays(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Récupère tous les pays qui existe dans l'association pays-bu
    http
      .get("pivot-client-bu/get-all-exist-pays-in-association")
      .then((res) => {
        Array.isArray(res.data) && setDataPaysInAssociations(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Récupère les pays pour le filtre
    http
      .get("saisie/manager/get-pays")
      .then((res) => {
        Array.isArray(res.data) && setDataFilteredPays(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    if (
      ![PROFIL_SUPER_ADMIN, PROFIL_ADV, PROFIL_DIRECTION].includes(
        user?.profils?.libelle
      )
    ) {
      // Déterminer la période auquel je peut saisir des quantités
      http
        .post("saisie/manager/get-period-to-enter/quantities")
        .then((res) => {
          setPeriodSaisi(res?.data?.period_saisi);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    // Recuperer Tous Les Periode Cloturé du Date Now
    http
      .post("saisie/manager/get-period-to-disable/quantities", {})
      .then((res) => {
        setAllPeriodeClotured(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  /**
   * @param pays
   * Recupère le BU par rapport au pays
   */
  const getBusinessUnits = async (pays: any) => {
    await http
      .get(`saisie/manager/get-bus/${pays}`)
      .then((res) => {
        Array.isArray(res.data) && setDataBusinessUnits(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * @param bu
   * Recupère les clients par rapport au pays et BU
   */
  const getClients = async (bu: any) => {
    await http
      .get(`saisie/manager/get-clients/${filter?.pays}/${bu}`)
      .then((res) => {
        Array.isArray(res.data) && setDataClients(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * @param client
   * Recupère les operations par rapport au pays, BU et client
   */
  const getOperations = async (client: any) => {
    await http
      .post(`saisie/manager/get-operations`, {
        pays: filter?.pays,
        bu: filter?.bu,
        client,
      })
      .then((res) => {
        Array.isArray(res.data) && setDataOperations(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * @param operation
   * Recupère les articles par rapport au pays, BU, client et operation
   */
  const getArticles = async (operation: any) => {
    await http
      .post(`saisie/manager/get-articles`, {
        pays: filter?.pays,
        bu: filter?.bu,
        client: filter?.client,
        operation,
      })
      .then((res) => {
        Array.isArray(res.data) && setDataArticles(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setPays = (value: any): void => {
    const datas: FilterParams = {
      ...initialFilter,
      pays: value,
    };
    setDataBusinessUnits([]);
    setDataClients([]);
    setDataOperations([]);
    setDataArticles([]);
    setFilter(datas);

    // on recupère le BU par rapport au pays
    getBusinessUnits(value);
  };

  const setBusinessUnit = (value: any): void => {
    const datas: FilterParams = {
      ...filter,
      bu: value,
      client: "",
      operation: "",
      article: "",
      date_debut: "",
      date_fin: "",
    };
    setDataClients([]);
    setDataOperations([]);
    setDataArticles([]);
    setFilter(datas);

    // on recupère les clients par rapport au pays et BU
    getClients(value);
  };

  const setClient = (value: any): void => {
    const datas: FilterParams = {
      ...filter,
      client: value,
      operation: "",
      article: "",
      date_debut: "",
      date_fin: "",
    };

    setDataOperations([]);
    setDataArticles([]);
    setFilter(datas);

    // on recupère les operations par rapport au pays, BU et client
    getOperations(value);
  };

  const setOperation = (value: any): void => {
    const datas: FilterParams = {
      ...filter,
      operation: value,
      article: "",
      date_debut: "",
      date_fin: "",
    };

    setFilter(datas);
    setDataArticles([]);
    getArticles(value);
  };

  const setDateDebut = (value: any): void => {
    setDateNotValidate(false);
    if (CheckAttr(filter?.date_fin)) {
      const dateDeb = new Date(value);
      const dateFin = new Date(filter?.date_fin);

      if (dateDeb.getTime() > dateFin.getTime()) {
        setAlerteMessage(
          "Désolé! La date début doit être inférieur ou égal à la date fin !"
        );
        setAlertType("warning");
        setOpenSnack(true);

        setDateNotValidate(true);
      } else {
        setFilter({
          ...filter,
          date_debut: value,
        });
      }
    } else {
      setFilter({
        ...filter,
        date_debut: value,
      });
    }
  };

  const setDateFin = (value: any): void => {
    setDateNotValidate(false);
    if (CheckAttr(filter?.date_debut)) {
      const dateDebut = new Date(filter?.date_debut);
      const dateFin = new Date(value);

      if (dateDebut.getTime() > dateFin.getTime()) {
        setAlerteMessage(
          "Désolé! La date fin doit être supèrieur ou égal à la date debut !"
        );
        setAlertType("warning");
        setOpenSnack(true);

        setDateNotValidate(true);
      } else {
        setFilter({
          ...filter,
          date_fin: value,
        });
      }
    } else {
      setFilter({
        ...filter,
        date_fin: value,
      });
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    switch (name) {
      case "pays":
        setPays(value);
        break;
      case "bu":
        setBusinessUnit(value);
        break;
      case "client":
        setClient(value);
        break;
      case "operation":
        setOperation(value);
        break;
      case "date_debut":
        setDateDebut(value);
        break;
      case "date_fin":
        setDateFin(value);
        break;
      default:
        setFilter({
          ...filter,
          [name]: value,
        });
        break;
    }
  };

  const handleSearch = () => {
    // Recherche par article
    setPage(1);
    setRowsPerPage(5);
    retrieveData();
  };

  const resetPage = () => {
    /* setFilter(initialFilter);
        setDataBusinessUnits([]);
        setDataClients([]);
        setDataOperations([]);
        setColumnToSort(undefined);
        setSortedColumn(0);
        setArticleSearch('');
        reloadList(); */
    window.location.reload();
  };

  const reloadPage = () => {
    setReloadList(!reloadList);

    if (filter?.pays) {
      getBusinessUnits(filter?.pays);

      if (filter?.bu) {
        getClients(filter?.bu);

        if (filter?.client) {
          getOperations(filter?.client);
        }
      }
    }
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleClose2 = () => {
    setOpenCumulModal(false);
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const setSortParams = (column: string, order: SortType) => {
    setColumnToSort({
      column,
      orderBy: order,
    });
  };

  const iconToUse = (id: number): JSX.Element => {
    let icon = <ArrowUpwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
    if (sortedColumn === id) {
      if (columnToSort && columnToSort.orderBy === "DESC") {
        icon = <ArrowDownwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
      }
    }

    return icon;
  };

  const pagination: JSX.Element | boolean = (
    <Stack spacing={2} direction="row">
      <InputLabel sx={{ color: "#fff" }}>Lignes par page :</InputLabel>
      <FormControl variant="standard" sx={{ minWidth: 50 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          color="warning"
          sx={{ background: "#fff", borderRadius: 1, paddingLeft: 1 }}
          value={rowsPerPage}
          onChange={(e) => setRowsPerPage(e.target.value as number)}
          defaultValue={5}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      {!isLoading && totalData > rowsPerPage && (
        <Pagination
          count={Math.ceil(totalData / rowsPerPage)}
          color="standard"
          sx={{ button: { color: "white" } }}
          showFirstButton={true}
          showLastButton={true}
          siblingCount={0}
          boundaryCount={1}
          defaultPage={page}
          onChange={(event, value) => setPage(value)}
        />
      )}
    </Stack>
  );

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  return (
    <>
      <Container maxWidth="xl">
        {isDesktopOrLaptop ? (
          <>
            <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }}>
              <Grid item xs={6} sm={2} md={3.25}>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  color="warning"
                  sx={{ textTransform: "none", mb: { xs: 2 } }}
                  onClick={() => setOpenModal(true)}
                  disabled={[PROFIL_GESTIONNER_HEURE_PROD].includes(user?.profils?.libelle)}
                >
                  Ajouter
                </Button>
                <Button
                  variant="contained"
                  startIcon={<FunctionsIcon />}
                  sx={{
                    textTransform: "none",
                    mb: { xs: 2 },
                    ml: 0.5,
                    color: "#fc8404",
                    background: "#fff",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                  onClick={() => setOpenCumulModal(true)}
                >
                  Cumul des articles
                </Button>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                  >
                    Pays
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="pays"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Pays"
                    value={filter?.pays}
                    onChange={handleChange}
                  >
                    {dataFilteredPays.map((pays) => (
                      <MenuItem key={pays?.id} value={pays?.id} dense>
                        {pays?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                  >
                    Business unit
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="bu"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Business unit"
                    value={filter?.bu}
                    onChange={handleChange}
                  >
                    {dataBusinessUnits.map((bu) => (
                      <MenuItem key={bu?.id} value={bu?.id} dense>
                        {bu?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                  >
                    Client
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="client"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Client"
                    value={filter?.client}
                    onChange={handleChange}
                  >
                    {dataClients.map((client) => (
                      <MenuItem key={client?.id} value={client?.id} dense>
                        {client?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                  >
                    Opération
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="operation"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Opération"
                    value={filter?.operation}
                    onChange={handleChange}
                  >
                    {dataOperations.map((operation) => (
                      <MenuItem key={operation?.id} value={operation?.id} dense>
                        {operation?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                  >
                    Article
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="article"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Article"
                    value={filter?.article}
                    onChange={handleChange}
                  >
                    {dataArticles.map((article) => (
                      <MenuItem key={article?.id} value={article?.id} dense>
                        {article?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <TextField
                  name="date_debut"
                  label="Date debut"
                  type="date"
                  color="warning"
                  size="small"
                  fullWidth
                  sx={{ backgroundColor: "#fff", borderRadius: 1 }}
                  value={filter?.date_debut}
                  error={dateNotValidate}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "#fff", marginTop: -7 },
                  }}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <TextField
                  name="date_fin"
                  label="Date fin"
                  type="date"
                  color="warning"
                  size="small"
                  fullWidth
                  sx={{ backgroundColor: "#fff", borderRadius: 1 }}
                  value={filter?.date_fin}
                  error={dateNotValidate}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "#fff", marginTop: -7 },
                  }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              spacing={0.5}
              columns={{ xs: 6, sm: 12, md: 12 }}
              sx={{ mt: 3 }}
            >
              <Grid item xs={6} sm={12} md={7}>
                <Box mt={2}>{pagination}</Box>
              </Grid>
              <Grid item xs={6} sm={12} md={5}>
                <Stack
                  direction="row"
                  spacing={3}
                  display="flex"
                  ml={3}
                  justifyContent="end"
                  mt={{ sm: 2, xs: 2 }}
                >
                  <InputBase
                    sx={{ color: "white" }}
                    value={articleSearch}
                    placeholder="Chercher un article ..."
                    onChange={(e) => setArticleSearch(e.target.value)}
                  />
                  <IconButton
                    type="button"
                    sx={{ p: "10px" }}
                    aria-label="search"
                    onClick={handleSearch}
                  >
                    <SearchIcon sx={{ color: "#fff" }} />
                  </IconButton>
                  <IconButton
                    aria-label="refresh"
                    sx={{ color: "#fff", pt: 0.5 }}
                    onClick={() => resetPage()}
                  >
                    <RefreshIcon sx={{ fontSize: 35 }} />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>

            <TableContainer component={Paper} style={tableStyle}>
              <Table>
                <TableHead>
                  <TableRow>
                    {tableColumnTittles.map((column) => (
                      <TabSort
                        key={column.id}
                        column={column}
                        icon={iconToUse(column.id)}
                        sortedColumn={sortedColumn}
                        setSortParams={setSortParams}
                        setSortedColumn={setSortedColumn}
                      />
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!isLoading &&
                    (totalData > 0 ? (
                      saisieAgents.map((saisieAgent) => (
                        <SaisieAgentRow
                          key={saisieAgent?.id}
                          isDesktopOrLaptop={isDesktopOrLaptop}
                          saisieAgent={saisieAgent}
                          periodSaisi={periodSaisi}
                          dataPays={dataPays}
                          http={http}
                          expanded={expanded}
                          setExpanded={setExpanded}
                          reloadList={reloadPage}
                          setOpenSnack={setOpenSnack}
                          setAlerteMessage={setAlerteMessage}
                          setAlertType={setAlertType}
                          allPeriodeClotured={allPeriodeClotured}
                        />
                      ))
                    ) : (
                      <StyledTableCell colSpan={12}>
                        Aucun resultat a été trouvé ...
                      </StyledTableCell>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box display="flex" justifyContent="right" mt={4} mb={6}>
              {pagination}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{
              position: 'fixed',
              width: '95%',
              top: '10.32rem',
              pr: 1.5,
              pt: 2,
              bgcolor: '#080d24',
              zIndex: 1000
            }}>
              <Button
                variant="contained"
                size="small"
                startIcon={<AddIcon />}
                color="warning"
                fullWidth
                sx={{ textTransform: "none" }}
                onClick={() => setOpenModal(true)}
              >
                Ajouter
              </Button>
              <Button
                fullWidth
                variant="contained"
                size="small"
                startIcon={<FunctionsIcon />}
                sx={{
                  textTransform: "none",
                  color: "#fc8404",
                  background: "#fff",
                  mt: 0.5,
                  mb: 1
                }}
                onClick={() => setOpenCumulModal(true)}
              >
                Cumul des articles
              </Button>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  Filtre
                </AccordionSummary>
                <AccordionDetails>
                  <FormControl sx={{ mt: 2.5 }} fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(filter?.pays) && "Pays"}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Pays"
                      name="pays"
                      value={filter?.pays}
                      onChange={handleChange}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataFilteredPays.map((pays) => (
                        <MenuItem key={pays?.id} value={pays?.id} dense>
                          {pays?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="bu" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(filter?.bu) && "Business unit"}
                    </InputLabel>
                    <Select
                      labelId="bu"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Business unit"
                      name="bu"
                      value={filter?.bu}
                      onChange={handleChange}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataBusinessUnits.map((bu) => (
                        <MenuItem key={bu?.id} value={bu?.id} dense>
                          {bu?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="client" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(filter?.client) && "Client"}
                    </InputLabel>
                    <Select
                      labelId="client"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Client"
                      name="client"
                      value={filter?.client}
                      onChange={handleChange}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataClients.map((client) => (
                        <MenuItem key={client?.id} value={client?.id} dense>
                          {client?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="operation" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(filter?.operation) && "Opération"}
                    </InputLabel>
                    <Select
                      labelId="operation"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Opération"
                      name="operation"
                      value={filter?.operation}
                      onChange={handleChange}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataOperations.map((operation) => (
                        <MenuItem key={operation?.id} value={operation?.id} dense>
                          {operation?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="article" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(filter?.article) && "Article"}
                    </InputLabel>
                    <Select
                      labelId="article"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Article"
                      name="article"
                      value={filter?.article}
                      onChange={handleChange}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataArticles.map((article) => (
                        <MenuItem key={article?.id} value={article?.id} dense>
                          {article?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <TextField
                      name="date_debut"
                      label={<Typography variant="subtitle1" color="GrayText">
                        Date debut
                      </Typography>}
                      type="date"
                      color="warning"
                      sx={{ borderRadius: 1, mt: 2.5 }}
                      size="small"
                      value={filter?.date_debut}
                      error={dateNotValidate}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "#fff", marginTop: -7 },
                      }}
                    />
                  </FormControl>

                  <FormControl fullWidth>
                    <TextField
                      name="date_fin"
                      label={<Typography variant="subtitle1" color="GrayText">
                        Date fin
                      </Typography>}
                      type="date"
                      color="warning"
                      sx={{ borderRadius: 1, mt: 2.5 }}
                      size="small"
                      value={filter?.date_fin}
                      error={dateNotValidate}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "#fff", marginTop: -7 },
                      }}
                    />
                  </FormControl>
                </AccordionDetails>
              </Accordion>

              <TextField
                id="outlined-basic"
                variant="outlined"
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 1,
                  mt: 1,
                  mb: 4
                }}
                placeholder="Chercher un article ..."
                size="small"
                fullWidth
                value={articleSearch}
                onChange={(e) => setArticleSearch(e.target.value)}
                color="warning"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label="search"
                        onClick={() => handleSearch()}
                      >
                        <SearchIcon />
                      </IconButton>
                      <IconButton aria-label="refresh" onClick={() => resetPage()}>
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Typography>Liste Saisies Managers</Typography>
              <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 2 }} />

              {!isLoading && totalData > rowsPerPage && (
                <Box display="flex" justifyContent="end">
                  <Pagination
                    count={Math.ceil(totalData / rowsPerPage)}
                    size="small"
                    color="standard"
                    sx={{ button: { color: "white" }, mb: 2 }}
                    showFirstButton={true}
                    showLastButton={true}
                    siblingCount={0}
                    boundaryCount={1}
                    defaultPage={page}
                    onChange={(event, value) => setPage(value)}
                  />
                </Box>
              )}
            </Box>

            <Box mt='17.5rem'>
              {saisieAgents.map((saisieAgent) => (
                <SaisieAgentRow
                  key={saisieAgent?.id}
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  saisieAgent={saisieAgent}
                  periodSaisi={periodSaisi}
                  dataPays={dataPays}
                  http={http}
                  expanded={expanded}
                  setExpanded={setExpanded}
                  reloadList={reloadPage}
                  setOpenSnack={setOpenSnack}
                  setAlerteMessage={setAlerteMessage}
                  setAlertType={setAlertType}
                  allPeriodeClotured={allPeriodeClotured}
                />
              ))}
            </Box>

            <Stack direction="row" sx={{ mt: 3, mb: 4 }}>
              <InputLabel sx={{ color: "#fff", fontSize: 12, mt: 0.5 }}>
                Lignes par page :
              </InputLabel>
              <FormControl variant="standard" sx={{ minWidth: 48 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  color="warning"
                  sx={{
                    background: "#fff",
                    borderRadius: 1,
                    paddingLeft: 1,
                    paddingTop: 0.5,
                    marginLeft: 1,
                    fontSize: 12,
                  }}
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(e.target.value as number)}
                  defaultValue={5}
                  size="small"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </>
        )}

        <OptionalWidthModal
          title="Saisie Production"
          breackPoint="lg"
          onClose={handleClose}
          open={openModal}
        >
          <AddSaisieAgentForm
            dataPaysInAssociations={dataPaysInAssociations}
            periodSaisi={periodSaisi}
            http={http}
            onClose={handleClose}
            reloadList={reloadPage}
            setOpenSnack={setOpenSnack}
            setAlerteMessage={setAlerteMessage}
            setAlertType={setAlertType}
            allPeriodeClotured={allPeriodeClotured}
          />
        </OptionalWidthModal>

        <OptionalWidthModal
          title="Cumul des articles"
          breackPoint="lg"
          onClose={handleClose2}
          open={openCumulModal}
        >
          <CumulArticle dataPays={dataPaysInAssociations} http={http} />
        </OptionalWidthModal>
      </Container>
      {stackAlert}
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default SaisieAgent;
